import { render, staticRenderFns } from "./DriverManagementPage.vue?vue&type=template&id=8413f07a&scoped=true"
import script from "./DriverManagementPage.vue?vue&type=script&lang=js"
export * from "./DriverManagementPage.vue?vue&type=script&lang=js"
import style0 from "./DriverManagementPage.vue?vue&type=style&index=0&id=8413f07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8413f07a",
  null
  
)

export default component.exports